export default "__VITE_ASSET__fv$O5uw9__"